module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/png/vision_en-f0d5f7765836cb300f27409325066c11.png";